import * as React from 'react';
import { SVGProps } from 'react';

const IconRemoveSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2 11h20v2H2z" />
  </svg>
);
export default IconRemoveSizeM;
